export const LOGIN_SU_USER = "LOGIN_SU_USER"
export const LOGIN_SU_SUCCESS = "LOGIN_SU_SUCCESS"

export const LOGOUT_SU_USER = "LOGOUT_SU_USER"
export const LOGOUT_SU_USER_SUCCESS = "LOGOUT_SU_USER_SUCCESS"
export const API_SU_ERROR = "API_SU_ERROR"

export const SOCIAL_SU_LOGIN = "SOCIAL_SU_LOGIN"
